export default function Contact() {
  return (
    <section id="contact" className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <h3 className="text-4xl font-bold text-gray-900 mb-4">
            Contact <span className="text-[#224cc4]">Us</span>
          </h3>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Get in touch with our experts for all your industrial component requirements
          </p>
        </div>

        <div className="max-w-4xl mx-auto">
          {/* Contact Information */}
          <div>
            <h4 className="text-2xl font-semibold text-gray-900 mb-8 text-center">
              Get In Touch
            </h4>
            
            <div className="max-w-2xl mx-auto">
              <div className="grid grid-cols-[auto_1px_1fr] gap-x-4 gap-y-6 items-start">
                {/* Row 1: Address */}
                <div className="w-12 h-12 bg-[#224cc4]/10 rounded-lg flex items-center justify-center">
                  <i className="ri-map-pin-line text-xl text-[#224cc4]"></i>
                </div>
                <div className="w-px bg-[#224cc4]/20 h-full min-h-[48px]"></div>
                <div>
                  <h5 className="font-semibold text-gray-900 mb-1">Address</h5>
                  <p className="text-gray-600">
                    Suncore International General Trading FZE<br />
                    WH-RA08TB03, Jebel Ali Free Zone<br />
                    Dubai, UAE
                  </p>
                </div>

                {/* Row 2: Phone */}
                <div className="w-12 h-12 bg-[#224cc4]/10 rounded-lg flex items-center justify-center">
                  <i className="ri-phone-line text-xl text-[#224cc4]"></i>
                </div>
                <div className="w-px bg-[#224cc4]/20 h-full min-h-[48px]"></div>
                <div>
                  <h5 className="font-semibold text-gray-900 mb-1">Phone</h5>
                  <p className="text-gray-600">+971 04 261 5620</p>
                </div>

                {/* Row 3: Email */}
                <div className="w-12 h-12 bg-[#224cc4]/10 rounded-lg flex items-center justify-center">
                  <i className="ri-mail-line text-xl text-[#224cc4]"></i>
                </div>
                <div className="w-px bg-[#224cc4]/20 h-full min-h-[48px]"></div>
                <div>
                  <h5 className="font-semibold text-gray-900 mb-2">Email</h5>
                  <div className="text-gray-600 space-y-3">
                    <div>
                      <p className="font-medium text-gray-700 mb-1">For Sales:</p>
                      <p>Sales1@suncore-uae.com</p>
                      <p>Sales2@suncore-uae.com</p>
                      <p>Sales3@suncore-uae.com</p>
                    </div>
                    <div>
                      <p className="font-medium text-gray-700 mb-1">For Accounts:</p>
                      <p>Accounts1@suncore-uae.com</p>
                    </div>
                    <div>
                      <p className="font-medium text-gray-700 mb-1">For Logistics:</p>
                      <p>Docs1@suncore-uae.com</p>
                    </div>
                  </div>
                </div>

                {/* Row 4: Business Hours */}
                <div className="w-12 h-12 bg-[#224cc4]/10 rounded-lg flex items-center justify-center">
                  <i className="ri-time-line text-xl text-[#224cc4]"></i>
                </div>
                <div className="w-px bg-[#224cc4]/20 h-full min-h-[48px]"></div>
                <div>
                  <h5 className="font-semibold text-gray-900 mb-1">Business Hours</h5>
                  <p className="text-gray-600">
                    Monday - Saturday: 8:00 AM - 5:00 PM<br />
                    Sunday: Closed
                  </p>
                </div>
              </div>
            </div>

            {/* Map */}
            <div className="mt-8 max-w-lg mx-auto">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3617.1782149186156!2d55.05927707539403!3d24.960050541265183!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3e5f0d293a8e1521%3A0xce1dbbee6e9bc6cf!2sSUNCORE%20INTERNATIONAL%20(GT)%20FZE!5e0!3m2!1sen!2sin!4v1782048507082!5m2!1sen!2sin"
                width="100%"
                height="250"
                style={{ border: 0 }}
                allowFullScreen
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                className="rounded-lg shadow-md"
                title="Suncore International Location"
              ></iframe>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}